import { useState, useCallback } from 'react';
import { Candidate, CandidateStatus } from '@recruitai/shared';
import { apiClient } from '../lib/api-client';

interface UseUpdateCandidateStatusResult {
  updateStatus: (newStatus: CandidateStatus) => Promise<Candidate | null>;
  isUpdating: boolean;
  error: Error | null;
}

export function useUpdateCandidateStatus(
  jobId: string,
  candidateId: string,
  onSuccess?: () => void
): UseUpdateCandidateStatusResult {
  const [isUpdating, setIsUpdating] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const updateStatus = useCallback(async (newStatus: CandidateStatus): Promise<Candidate | null> => {
    try {
      setIsUpdating(true);
      setError(null);

      const result = await apiClient.patch<Candidate>(
        `/jobs/${jobId}/candidates/${candidateId}/status`,
        { status: newStatus }
      );

      onSuccess?.();
      return result;
    } catch (err) {
      const error = err instanceof Error ? err : new Error('Falha ao atualizar status');
      setError(error);
      return null;
    } finally {
      setIsUpdating(false);
    }
  }, [jobId, candidateId, onSuccess]);

  return { updateStatus, isUpdating, error };
}
